// Mobile menu: aggiungi link "Vedi tutto" per voci con sub-items
(function(){
  function addViewAll(){
    document.querySelectorAll('.menu-drawer summary').forEach(s => {
      const details = s.parentElement;
      if (!details || details.tagName !== 'DETAILS') return;
      if (details.dataset.artopViewallAdded) return;
      // Find the parent link href
      const titleSpan = s.querySelector('span') || s;
      const text = (titleSpan.textContent || '').trim();
      if (!text) return;
      // Look for matching collection by guessing handle from text
      const handle = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      // Inject "Vedi tutto" as first list item inside the panel
      const panel = details.querySelector('.menu-drawer__submenu, ul');
      if (!panel) return;
      const li = document.createElement('li');
      li.className = 'menu-drawer__list-item';
      li.innerHTML = '<a href="/collections/' + handle + '" class="menu-drawer__menu-item link link--text focus-inset" style="font-weight:600;color:#B8860B;">→ Tutti i prodotti ' + text + '</a>';
      panel.insertBefore(li, panel.firstChild);
      details.dataset.artopViewallAdded = '1';
    });
  }
  addViewAll();
  // Re-run on detail open
  document.addEventListener('click', e => {
    if (e.target.closest('.menu-drawer summary, .menu-drawer details')) setTimeout(addViewAll, 50);
  });
  new MutationObserver(addViewAll).observe(document.body, { childList: true, subtree: true });
})();
